<template>
  <div id="app">
    <glass-on-plugin />
  </div>
</template>

<script>
import { GlassOnPlugin } from "./components/GlassOnPlugin";

export default {
  components: {
    GlassOnPlugin
  }
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Blinker:wght@400;600;700&display=swap");

#app {
  font-family: "Blinker", "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

.pd-modal {
  .ant-modal-content {
    border-radius: 32px;
  }
}

.tryon-content-wrapper {
  .ant-spin-container {
    height: 100%;
  }
}

.enter-box {
  .ant-input {
    // border-top-left-radius: 8px;
    // border-bottom-left-radius: 8px;
    border-radius: 8px;
  }

  &.shake {
    .ant-input {
      font-size: 24px;
      line-height: 2;
    }
  }

  .ant-btn {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
  }
}
</style>
